import { Label } from "src/base-components/Label";
import { MarkdownRenderer } from "src/base-components/MarkdownRenderer/MarkdownRenderer";
import { CaseTemplateFormFieldsInner } from "src/clients/case-management";

type FormFieldLabelProps = {
  field: CaseTemplateFormFieldsInner;
};

export const FormFieldLabel: React.FC<FormFieldLabelProps> = ({ field }) => (
  <>
    <Label mb={field.description ? "mb-0" : "mb-2"} required={field.required}>
      {field.display_name}
    </Label>
    {field.description && (
      <div className="mb-2">
        <MarkdownRenderer content={field.description} variant="muted" />
      </div>
    )}
  </>
);
